// extracted by mini-css-extract-plugin
export default {"heading_container":"Heading_heading_container__sYQUs","heading":"Heading_heading__mwArR"};